import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";

async function fetchAllData() {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };
  let searchQueryEmployeeData = new URLSearchParams({
    ...searchOptions,
    status: 0,
  }).toString();
  const [department, saleArea, saleBlock, businessCategory, branch, employee] =
    await Promise.all([
      clientAPI("get", `/department?page=1&limit=9999`),
      clientAPI("get", `/saleArea?page=1&limit=9999`),
      clientAPI("get", `/saleBlock?page=1&limit=9999`),
      clientAPI("get", `/businessCategory?page=1&limit=9999`),
      clientAPI("get", `/branch?page=1&limit=9999`),
      clientAPI("get", `/employee?${searchQueryEmployeeData}`),
    ]);

  return {
    department:
      department?.items?.map((item) => ({
        id: item._id,
        code: item.code,
        name: item.name,
      })) || [],
    saleArea:
      saleArea?.items?.map((item) => ({
        id: item._id,
        code: item.code,
        name: item.name,
        branch: item.branch?.name || "-",
        branchId: item.branchId,
        managerId: item?.managerId,
        manager: item?.manager?.fullName || "-",
      })) || [],
    saleBlock:
      saleBlock?.items?.map((item) => ({
        id: item._id,
        code: item.code,
        name: item.name,
        saleArea: item.saleArea?.name || "-",
        saleAreaId: item.saleAreaId,
        managerId: item?.managerId,
        manager: item?.manager?.fullName || "-",
        isChallengeBlock: item?.isChallengeBlock || false,
      })) || [],
    saleAreaSelect:
      saleArea?.items?.map((item) => ({
        value: item._id,
        label: item.name,
      })) || [],
    businessCategory:
      businessCategory?.items?.map((item) => ({
        id: item._id,
        code: item?.code || "",
        name: item?.name || "",
        rate: item?.rate || 0,
        is_related_other_type: item?.is_related_other_type || false,
        min_working_days: item?.min_working_days || 0,
        related_to: item?.related_to || "",
      })) || [],
    businessCategorySelect:
      businessCategory?.items?.map((item) => ({
        value: item._id,
        label: item.name,
      })) || [],
    branchSelect:
      branch?.items?.map((item) => ({
        value: item._id,
        label: item.name,
      })) || [],
    employeeSelect: employee?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.fullName }),
      {},
    ),
  };
}

export function usePersonnelStructure() {
  const { data, isLoading, isRefetching, error, refetch } = useQuery({
    queryKey: ["allData"],
    queryFn: fetchAllData,
    refetchOnWindowFocus: false,
  });

  return {
    department: data?.department || {},
    saleArea: data?.saleArea || {},
    saleBlock: data?.saleBlock || {},
    saleAreaSelect: data?.saleAreaSelect || {},
    branchSelect: data?.branchSelect || {},
    businessCategory: data?.businessCategory || {},
    businessCategorySelect: data?.businessCategorySelect || {},
    employeeSelect: data?.employeeSelect || {},
    isLoading,
    isRefetching,
    error,
    refetch,
  };
}
